<template src='./toogle.pug' lang='pug'></template>

<script>
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'Toogle',

  props: {
    labelLeft: {
      type: String
    },
    labelRight: {
      type: String
    },
    idLeft: {
      type: String,
      required: true
    },
    idRight: {
      type: String,
      required: true
    },
    handleSelection: { // Evento retornacá TRUE caso o toogle selecionado seja o da esquerda
      type: Function,
      required: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    trackEvent (idSelected) {
      trackAnalyticsEvent(this, 'toogle-click', 'toogle-component', this[idSelected])
      if (typeof this.handleSelection !== 'undefined') {
        this.handleSelection(idSelected === 'idLeft')
      }
    }
  }
}
</script>

<style lang='css' scoped>
.toogle-primary {
  background-color: #1c3b60;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
}

.toogle-secondary {
  color: #666;
  background-color: #fff;
  border-color: #999;
}

.toogle-secondary:hover {
  color: #666;
  background-color: #EFEFEF;
  border-color: #999;
}

.toogle-secondary[disabled] {
  background-color: #EFEFEF;
  border: 1px solid #ccc;
  color: #666;
}

.toogle-secondary[disabled]:hover {
  background-color: #EFEFEF;
  border: 1px solid #ccc;
}
</style>




// WEBPACK FOOTER //
// Toogle.vue?479fe206